export const en = {
  message: {
    layout: {
      login: 'Login',
      logout: 'Logout',
      customers: 'Customers',
      crm: 'CRM',
      settings: 'Settings',
      timer: 'Time Management',
      user: 'Users',
      userRole: 'User Roles',
      productType: 'Product Types',
      priorities: 'Priorities',
      ticketStatus: 'Ticket Status',
      ticketTypes: 'Ticket Types',
      department: 'Departments',
      groups: 'Groups',
      ticket: 'Tickets',
      mailConfiguration: 'Mail Configuration',
      systemConfiguration: 'System Configuration',
      hse: 'HSE',
      product: 'Product',
      products: 'Products',
      order: 'Order',
      deviation: 'Deviation',
      deviationCategory: 'Deviation Category',
      deviationLocation: 'Deviation Location',
      deviationStatus: 'Deviation Status',
      deviationMeasures: 'Deviation Measures',
      measureStatus: 'Measure status',
      measureCategory: 'Measure Category',
      deviationSettingStatus: 'Status',
      onedriveSetting: 'OneDrive Setting',
      sharepointSetting: 'Sharepoint Setting',
      sharepointCredential: 'Sharepoint Credential',
      filesFromSharepoint: 'Select file(s) from sharepoint',
      noFiles: 'No files found on sharepoint for this order!',
      filesAdded: 'Files that are added',
      clearOneDrive: 'Clear One Drive',
      category: 'Category',
      location: 'Location',
      loc: 'Loc.',
      priority: 'Priority',
      status: 'Status',
      deviations: 'Deviations',
      tickets: 'Tickets',
      types: 'Types',
      sharepoint: 'Sharepoint',
      crmSettings: 'CRM Settings',
      industries: 'Industries',
      shipments: 'Shipments',
      permission: 'Permissions',
      currencies: 'Currencies',
      salesAccounts: 'Sales Accounts',
      productGroup: 'Product groups',
      productUnit: 'Product unit',
      warehouseSettings: 'Warehouse settings',
      warehouse: 'Warehouse',
      warehouseLocations: 'Warehouse locations',
      offer: 'Offer',
      grossMargin: 'Gross margin',
      discountGroups: 'Discount groups',
      discountGroup: 'Discount group',
      orderOrOffer: 'Offer/Order',
      salesOrOffer: 'Sales/Offer',
      invoiceSettings: 'Invoice Settings',
      invoices: 'Invoices',
      dashboard: 'Dashboard',
      reports: 'Reports',
      mailAddressFilter: 'Mail address filter',
      advanced: 'Advanced',
      sales: 'Sales',
      totalTurnoverPerResponsible: 'Total Turnover per Responsible',
      checklist: 'Checklist',
      checklists: 'Checklists',
      totalCount: 'Total count',
      show: 'Show'
    },
    login: {
      language: 'Language',
      back: 'Back',
      userName: 'Username',
      password: 'Password',
      authFailed: 'Authentication failed !',
      enterUserName: 'Enter User Name',
      enterPassword: 'Enter Password',
      enterConfirmPassword: 'Confirm Your Password',
      resetNow: 'Reset Now',
      invalidPassword: 'Invalid Password',
      unauthorizedMsg: 'You are not authorized',
      forgotPassword: 'Forgot password?',
      mailNotFound: 'Email not found',
      linkShared: 'Reset link has been successfully sent!',
      office365: 'Login in with Office 365',
      or: 'Or'
    },
    common: {
      order: 'Order',
      english: 'English',
      norwegian: 'Norwegian',
      save: 'Save',
      send: 'Send',
      edit: 'Edit',
      cancel: 'Cancel',
      update: 'Update',
      delete: 'Delete',
      updateAndClose: 'Update & Close',
      close: 'Close',
      new: 'New',
      isActive: 'Is active',
      isClosed: 'Is closed',
      closedOn: 'Closed',
      addNew: 'Add new',
      savedSuccess: 'Saved successfully!',
      addedSucess: 'Added successfully !',
      updatedSuccess: 'Updated successfully !',
      uploadedSuccess: 'Uploaded successfully !',
      deleteSuccess: 'Deleted successfully !',
      exportedSuccess: 'Exported successfully !',
      backToList: 'Back To List',
      search: 'Search',
      yes: 'Yes',
      no: 'No',
      isDefault: 'Is Default',
      deleteMsg: 'Deleted Successfully',
      loadingMsg: 'Loading, Please wait',
      deleteConfirm: 'Delete Confirm',
      areYouSure: 'Are you sure you want to delete ?',
      validationIssue: 'Please check the required fields!',
      total: 'Total',
      noResults: 'No results found !',
      others: 'Others',
      typeHere: 'Type here...',
      position: 'Position',
      color: 'Color',
      maxCharacters: 'Max {charCount} characters',
      changedPassword: 'Password Changed Successfully',
      import: 'Import',
      note: 'Note',
      invalidEmail: 'Invalid Email',
      no_records: 'No Records Found!',
      ok: 'Ok',
      syncedSuccess: 'Synced Successfully',
      createMsg: 'Created Successfully',
      updateMsg: 'Updated Successfully',
      comment: 'Comment',
      comments: 'Comments',
      export: 'Export',
      importProducts: 'Import Products',
      exportProducts: 'Export Products',
      importSuppliers: 'Import Suppliers',
      importSuccess: 'Imported successfully!',
      days: 'Days',
      draft: 'Draft',
      ready: 'Ready',
      sent: 'Sent',
      accepted: 'Accepted',
      notAccepted: 'Not accepted',
      createOrder: 'Create order',
      ordered: 'Ordered',
      inProgress: 'In Progress',
      receiving: 'Receiving',
      received: 'Received',
      receivedDate: 'Received date',
      receive: 'Receive',
      partiallyReceived: 'Partially Received',
      request: 'Request',
      partiallyPicked: 'Partially Picked',
      picked: 'Picked',
      pickedqty: 'Pick qty',
      pickQ: 'Picked',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      qtyExceeds: 'Qty Exceeds',
      difference: 'Difference',
      completedBy: 'Completed by',
      completedAt: 'Completed at',
      completed: 'Completed',
      complete: 'Complete',
      ccsheet_warehouse_exists: 'In complete sheets are available for this warehouse/product groups',
      batchExists: 'Batch number already exists!',
      actionPerformed: 'Action performed successfully !',
      receivedOn: 'Received on',
      add_extra_mails: 'NOTE: Please use comma(,) to add multiple email ids',
      copy_to_me: 'Copy to me',
      order_report: 'Order report',
      orderConfirm: 'Order confirmation',
      offerConfirm: 'Offer PDF',
      offerWithZone: 'Offer w/sone totals',
      orderConfirmWithData: 'Order confirmation w/datasheet',
      commercialInvoice: 'Commercial Invoice',
      invalidDataFound: 'Invalid data found!',
      warning: 'Warning',
      changes_saved: 'You haven\'t saved your changes',
      are_you_navigate: 'Are you sure want to navigate ?',
      warning_saved: 'Changes have not been saved',
      save_continued: 'Do you want to save and continued ?',
      information: 'Information',
      both: 'Both',
      add: 'Add',
      status: 'Status',
      multiEmailHint: 'NOTE: Please use comma(,) to add multiple email ids',
      confirmation: 'Confirmation',
      no_data: 'No data available',
      noNotes: 'No Notes added',
      noComments: 'No Comments added',
      modifiedOn: 'Modified On',
      modifiedBy: 'Modified By',
      searchTriggerHint: '(Hit enter or click search icon)',
      startTyping: 'Start typing to search',
      reset: 'Reset',
      emailAddress: 'Email address',
      thisweek: 'This week',
      thismonth: 'This month',
      thisyear: 'This year',
      custom: 'Custom',
      month: 'Month',
      year: 'Year',
      week: 'Week',
      noData: 'No data',
      importFailed: 'Import failed!',
      dragAndFilesHere: 'Drag and Drop file(s) here (or)',
      clickHere: 'Click here',
      uploadFiles: 'to upload attchment files',
      change: 'Change',
      changeLocation: 'Change location',
      reload: 'Refresh',
      invalidMobileno: 'Mobile/Telephone is not valid',
      invalidWeekNumber: 'Weeknumbers are 1 to 53'
    },
    customer: {
      name: 'Name',
      address: 'Address',
      addressType: 'Type',
      country: 'Country',
      post: 'Post',
      city: 'City',
      municipality: 'Municipality',
      phone: 'Phone',
      email: 'Email',
      web: 'Web',
      description: 'Description',
      addCustomer: 'Add Customer',
      updateCustomer: 'Update Customer',
      contacts: 'Contacts',
      addContact: 'Add Contact',
      updateContact: 'Update Contact',
      telephone: 'Telephone',
      mobile: 'Mobilephone',
      jobTitle: 'Job title',
      addAddress: 'Add Address',
      updateAddress: 'Update Address',
      postbox: 'Post box',
      postCode: 'Post code',
      latitude: 'Latitude',
      longitude: 'Longitude',
      coordinates: 'Coordinates',
      isStandard: 'Is standard',
      standard: 'Standard',
      receiveCertificate: 'Receive Certificate',
      customerOrSupplier: 'Customer/Supplier',
      activeOrInactive: 'Active/Inactive',
      active: 'Active',
      Inactive: 'Inactive',
      status: 'Status',
      priority: 'Priority',
      buyingCustomer: 'Buying customer',
      potentialCustomer: 'Potential customer',
      vat: 'VAT',
      vatValue: 'VAT',
      vatId: 'VAT',
      homepage: 'Homepage',
      visit: 'Visit',
      delivery: 'Delivery',
      installed: 'Installed',
      invoice: 'Invoice',
      issupplier: 'Is Supplier',
      usebaseprices: 'Use Base Prices',
      iscustomer: 'IsCustomer',
      state: 'State',
      sg: 'Factoring',
      direct: 'Direct',
      ehf: 'EHF',
      pdf: 'PDF',
      paymentmethod: 'Payment',
      invoicetype: 'Invoice type',
      industry: 'Industry',
      shipment: 'Shipment',
      shipmentReport: 'Shipment',
      shipmentPurchase: 'Sendemåte',
      accountnumber: 'Account number',
      addSalesAccount: 'Add Sales account',
      updateSalesAccount: 'Update Sales account',
      norwegianLoc: 'Norwegian',
      foreign: 'Foreign',
      addons: 'Addons',
      noProductGroupsFound: 'No product groups found!',
      productGroup: 'Product group',
      notificationEmail: 'Notification e-mail',
      invoiceEmail: 'Invoice email',
      organizationNumber: 'Organization number',
      customerNumber: 'Customer number',
      mainSupplier: 'Main supplier',
      secondarySupplier: 'Secondary supplier',
      priceList: 'Price list',
      exists: 'Customer exists in CRM',
      customerGroup: 'Customer group',
      validUntil: 'Valid until',
      productionAllowed: 'Production allowed',
      twentyFourSeven: '24seven',
      noSupplier: 'No supplier'
    },
    user: {
      firstName: 'First name',
      lastName: 'Last name',
      addUser: 'Add User',
      updateUser: 'Update User',
      email: 'Email',
      mobile: 'Mobile',
      role: 'Role',
      pin: 'PIN',
      addRole: 'Add User Role',
      updateRole: 'Update User Role',
      profile: 'Profile',
      undo: 'Undo',
      clear: 'Clear',
      sendMailNotify: 'Like to get notification from ticketing system',
      externalEmployeeCode: 'External employee code',
      group: 'Group',
      signature: 'Your signature'
    },
    warehouse: {
      stock: 'Stock',
      order: 'Order',
      orderRepo: 'Order',
      ccsheet: 'CCSheet',
      product: 'Product',
      productName: 'Product name',
      addWarehouse: 'Add Warehouse',
      updateWarehouse: 'Update Warehouse',
      addLocation: 'Add Warehouse Location',
      updateLocation: 'Update Warehouse Location',
      warehouseSync: 'Sync to Shopbox & Opencart',
      openStructure: 'Open structure',
      openOrders: 'Open orders',
      lowStockProposal: 'Low stock proposal',
      lowStockTitle: 'Low stock order proposal',
      warningAboutOrder: 'Would you like to create supplier order with selected rows?',
      createAndEmail: 'Create and email',
      createOnly: 'Create only',
      createOrder: 'Create order',
      ordersCreatedSuccess: 'Order(s) are created successfully!',
      drawing: 'Drawing',
      addPackageOrContent: 'Would you like to add Package or its contents?',
      contents: 'Add contents',
      quickChangeLocation: 'Quick change location',
      partial: 'Partial',
      full: 'Full',
      quick: 'Quick',
      inProduction: 'In production',
      notAValidLocation: 'Not a valid location!',
      warehouseExists: 'Warehouse already exists!',
      suggested: 'Suggested',
      moveProduct: 'Move product',
      changeDefaultLoc: 'Change default location',
      showAllLocations: 'Show all locations with stock on pick list'
    },
    order: {
      productNotFound: 'Product Not Found',
      orderdocuments: 'Order Documents',
      orderdetails: 'Order Details',
      customer: 'Customer',
      startDate: 'Start date',
      endDate: 'End date',
      bas: 'Bas',
      manager: 'Manager',
      date: 'Date',
      deliveryDate: 'Delivery date',
      pickedDate: 'Picked date',
      deliveredQty: 'Delivered',
      shippingDate: 'Delivery date',
      contactPerson: 'Contact person',
      yourContactPerson: 'Your contact',
      contactPhone: 'Contact telephone',
      updatedOn: 'Updated on',
      details: 'Details',
      lines: 'Lines',
      documents: 'Documents',
      summary: 'Summary',
      orderName: 'Order Name',
      offerNumber: 'Offer Number',
      orderNumber: 'Order Number',
      statusName: 'Status Name',
      paymentTerm: 'Payment Terms',
      deliveryTerm: 'Delivery terms',
      paymentDate: 'Payment Date',
      agentName: 'Agent Name',
      customerReference: 'Customer Reference',
      deliveryCondition: 'Delivery Condition',
      customerContactPerson: 'Customer Contact Person',
      deadlineDate: 'Deadline Date',
      notes: 'Notes',
      netprice: 'Net Price',
      estimatedhourscost: 'Estimated Hours Cost',
      estimatedtotalcosts: 'Estimated Total Costs',
      actualhourscost: 'Actual Hours Cost',
      actualtotalcosts: 'Actual Total costs',
      totalCost: 'Total cost',
      estimatedcontributionmargin: 'Estimated Contribution Margin',
      estimatedcontributionmarginratio: 'Estimated Contribution Margin Ratio',
      actualcontributionmargin: 'Actual Contribution Margin',
      actualcontributionmarginratio: 'Actual Contribution Margin Ratio',
      plannedhours: 'Planned Hours',
      plannedservedhours: 'Planned Served Hours',
      plannedprogress: 'Planned Progress',
      actualhours: 'Actual Hours',
      actualservedhours: 'Actual Served Hours',
      actualprogress: 'Actual Progress',
      noSummariesFound: 'No summeries found!',
      qty: 'Qty',
      height: 'Height',
      customername: 'Customer Name',
      unitprice: 'Unit Price',
      measureunit: 'Measure Unit',
      totalnetprice: 'Total Net Price',
      totalprice: ' Total Price',
      actualplandate: 'Actual Plan Date',
      actualstartdate: 'Actual Start Date',
      actualenddate: 'Actual End Date',
      certificate: 'Certificate',
      supplier: 'Supplier',
      batchNumber: 'Batch Number/ Sportings Number',
      article: 'Article',
      download: 'Download',
      share: 'Share',
      emailNote: 'Please use comma(,) to add multiple email ids',
      searchByBatchNumber: 'Search by Batch number',
      showOrderRequire: 'Show orders require cert',
      recreateCertificate: 'Recreate Certificate',
      syncNow: 'Sync Now',
      sendToCustomer: 'Send to customer',
      sendToDefined: 'Send to defined',
      batchNo: 'Batch no.',
      myOrder: 'My orders',
      order: 'Order',
      unableToDelete: 'Unable to delete!',
      orderBillingData: 'Billing data',
      orderOffer: 'Offer/Order',
      myTasks: 'My tasks',
      offerAccepted: 'Offer is accepted and new order will be created. Do you want to continue?',
      orderedQtyHigh: 'Qty received is higher than ordered, would you like to proceed?',
      paymentTerms: 'Payment terms',
      totalVAT: 'Total VAT',
      rest: 'Rest',
      asMainSupplier: 'As main supplier',
      approval: 'Approval',
      approveSelected: 'Approve selected',
      reverseApproval: 'Reverse approval',
      purchase: 'Purchase',
      supplierOrderCreationText: 'Would you like to generate purchase orders?',
      allProducts: 'All products',
      lowOnStock: 'Low on stock products',
      searchLocation: 'Search location',
      productsNotPicked: 'Some products have not been picked. What would you like to do?',
      invoiceWithRest: 'Invoice with rest order',
      invoiceWithoutRest: 'Invoice without rest order',
      productionOrder: 'Production order',
      kilabOrder: 'Kilab order',
      sendOrderConfirmation: 'Send order confirmation',
      sendOffer: 'Send offer',
      sendOrder: 'Send order',
      sendInvoice: 'Send invoice',
      sendCredit: 'Send credit note',
      sendSales: 'Send sales',
      pickOrder: 'Pick order',
      toBePicked: 'To be picked',
      productsPickedSuccessfully: '{count} products are picked!',
      noProductsFoundForPicking: 'No products found for picking!',
      invoiceDeliveryAddress: 'Invoice delivery address',
      last: 'Last',
      supplierOnOrder: 'Select supplier on order',
      supplierNotSelected: 'Supplier not selected',
      purchaseList: 'Purchase list',
      orderlist: 'Orderlist',
      notStockItem: 'Non stock item',
      exportToExcel: 'Export to Excel',
      confirmationWithZone: 'Order confirmation w/sone totals',
      sureToUndo: 'Do you want to undo the pick of {qty} of {product_number}?',
      stockRevered: 'Stock have been reversed!',
      salesOrder: 'Sales order',
      labeled: 'Label',
      probability: 'Probability',
      productPrice: 'Product price',
      orderCreated: 'Order created',
      noOrder: 'No order',
      createOrder: 'Create order',
      cannotCreateOrderWithChildRows: 'Cannot create order with child rows',
      noValidRowsForOrder: 'No valid rows found to create order!',
      orderCreatedSuccessfully: 'Order created successfully!',
      errorOccurred: 'Error occurred!'
    },
    certificate: {
      create: 'Create',
      reCreate: 'Recreate'
    },
    document: {
      title: 'Document',
      codename: 'Code Name',
      datecreated: 'Created at',
      documentnumber: 'Number',
      text: 'Text',
      cost: 'Cost',
      statusdate: 'Status Date',
      versionHistory: 'Version History',
      versionLabel: 'Version Label',
      size: 'Size',
      versioningDocuments: 'Versioning Documents',
      builder: 'Document builder',
      module: 'Module',
      firstPageContent: 'Firstpage content',
      addReport: 'Add report',
      updateReport: 'Update report',
      chooseTemplate: 'Choose Template',
      copyDocuments: 'Copy documents',
      submit: 'Submit',
      copy: 'Copy',
      quickReport: 'Quick report',
      downloadOnly: 'Download only',
      downloadSave: 'Download & save',
      onlySave: 'Only save',
      loadFromRoot: 'Load from root',
      copiedMsg: 'Copied successfully'
    },
    template: {
      add: 'Add Template',
      update: 'Update Template',
      templates: 'Templates',
      sharepointFields: 'Sharepoint fields (Title: Placeholder)',
      moduleFields: 'Module fields (Title: Placeholder)',
      placeholderUsageMessage: 'Use placeholders within {} in templates. Ex: {Name}'
    },
    product: {
      addAtleastOneUnit: 'Add atleast one unit and one supplier unit',
      addProduct: 'Add Product',
      updateProduct: 'Update Product',
      number: 'Number',
      numberBarcode: 'Number barcode',
      shortName: 'Short name',
      unit: 'Unit',
      units: 'Units',
      qty: 'Qty',
      minQty: 'Min Qty',
      salesUnit: 'Sales unit',
      orderUnit: 'Order unit',
      packageQty: 'Package qty',
      monthUsage: '12m usage',
      supplier: 'Supplier',
      ean: 'EAN',
      length: 'Length (m)',
      width: 'Width (m)',
      thickness: 'Thickness (m)',
      weight: 'Net weight',
      grossWeight: 'Gross weight',
      netweightTotal: 'Netweight total',
      grossweightTotal: 'Grossweight total',
      certificateReq: 'Certificate required',
      type: 'Type',
      image: 'Image',
      ignoreDiscount: 'Ignore discount',
      measureUnit: 'Measure unit',
      radius: 'Radius (mm)',
      minLength: 'Min length (m)',
      minWidth: 'Min width (m)',
      minHeight: 'Min height',
      minThickness: 'Min thickness (m)',
      maxLength: 'Max length (m)',
      maxWidth: 'Max width (m)',
      maxHeight: 'Max height',
      maxThickness: 'Max thickness (m)',
      area: 'Area',
      supplierName: 'Supplier name',
      supplierNo: 'Supplier nbr',
      articleNumber: 'Article number',
      articleName: 'Article name',
      isStockItem: 'Stock item',
      isNotInventoryItem: 'Not Inventory item',
      grossMargin: 'Gross margin %',
      minStock: 'Min stock',
      maxstockqty: 'Max stock qty',
      restockqty: 'Restock qty',
      deliveryDays: 'Delivery days',
      deleteImage: 'Delete Image',
      addProductGroup: 'Add Product Group',
      updateProductGroup: 'Update Product Group',
      costs: 'Costs',
      taskName: 'Task name',
      hours: 'Hours',
      netCostPrice: 'Net cost price',
      additionalCostPer: 'Additional cost percentage',
      currencyExchange: 'Currency exchange rate',
      costPrice: 'Cost price',
      salePrice: 'Sale price',
      salePriceExVat: 'Sales price ex vat',
      salePriceIncVat: 'Sales price incl vat',
      addSupplierItem: 'Add supplier item',
      updateSupplierItem: 'Update supplier item',
      discount: 'Discount',
      addBatchNumber: 'Add batch number',
      updateBatchNumber: 'Update batch number',
      work: 'Work',
      prices: 'Prices',
      priceValidFrom: 'Price valid from',
      salesAccount: 'Sales account',
      stocks: 'Stocks',
      available: 'Available',
      orderQty: 'Order qty',
      measures: 'Measures',
      suppliers: 'Suppliers',
      supplierPrice: 'Supplier price',
      supplierDiscount: 'Supplier discount%',
      discounted: 'Discounted',
      shipmentAddon: 'Shipment addon',
      other: 'Other',
      currency: 'Currency',
      realCost: 'Real cost',
      realCostNOK: 'Real cost (NOK)',
      isMain: 'Is Main',
      isPackage: 'Is Package',
      packageProducts: 'Package products',
      shipment: 'Shipment %',
      other_per: 'Other %',
      batchRequired: 'Batch',
      barcode: 'Barcode',
      attachments: 'Attachments',
      file: 'File',
      chooseFile: 'Choose file',
      batches: 'Batches',
      batchNumber: 'Batch number',
      printLbl: 'Print label',
      reportIsReady: 'Report generation is under progress, it will be sent in mail when it is ready',
      selectPreferredSize: 'Select Preferred Size',
      print: 'Print',
      exportMsg: 'The export file is being genereated, it will be sent to your mail when ready',
      salesPrice: 'Sales Price',
      basePrice: 'Base Price',
      productWithSameNumberExists: 'Product with same number exists!',
      priceAdj: 'Price adj.',
      adjustByIn: 'Adjust by in %',
      dateFrom: 'Date from',
      priceAdjustments: 'Price adjustments',
      priceHistory: 'Price history',
      wayOfUpdate: 'Way of update',
      by_direct_update: 'By direct',
      by_mass_adjust: 'By mass adjustment',
      by_import: 'By import',
      priceAdjustmentAdded: 'The price history is added, and will take effect from respective date',
      exportAllData: 'Export all data',
      importAllData: 'Import all data',
      exportSupplierPrices: 'Export supplier prices',
      importSupplierPrices: 'Import supplier prices',
      supplierPriceAdjustment: 'Supplier price adjustment',
      leadTime: 'Lead time (days)',
      package: 'Package',
      supplierUnit: 'Supplier unit',
      addPackage: 'Add package',
      production: 'Production',
      numberSearch: 'Search by number',
      nameSearch: 'Search by name',
      isInformation: 'Information',
      defaultLocation: 'Default locations',
      typeOfOther: 'Type O',
      typeOfShipment: 'Type S'
    },
    priority: {
      addPriority: 'Add Priority',
      updatePriority: 'Update Priority'
    },
    ticketStatus: {
      addTicketStatus: 'Add Ticket Status',
      updateTicketStatus: 'Update Ticket Status',
      canClose: 'Can close'
    },
    ticketCategory: {
      addTicketCategory: 'Add Ticket Category',
      updateTicketCategory: 'Update Ticket Category'
    },
    group: {
      addGroup: 'Add Group',
      updateGroup: 'Update Group',
      addDiscountGroups: 'Add Discount groups',
      updateDiscountGroups: 'Update Discount groups'
    },
    tickets: {
      createTicket: 'Create Ticket',
      updateTicket: 'Update Ticket',
      createType: 'Create Type',
      updateType: 'Update Type',
      merge: 'Merge',
      ticketMerge: 'Tickets Merge',
      chooseParentTicket: 'Choose Parent Ticket',
      changeStatus: 'Change Status',
      changePriority: 'Change Priority',
      changeAssignedTo: 'Change Assigned To',
      assignTo: 'Assign To',
      delete: 'Delete',
      actions: 'Actions',
      mailbox: 'MailBox',
      assignedTo: 'Assigned To',
      unread: 'Unread',
      number: 'Number',
      status: 'Status',
      type: 'Type',
      tags: 'Tags',
      priority: 'Priority',
      from: 'From',
      subject: 'Subject',
      createdOn: 'Created On',
      created: 'Created',
      to: 'To',
      cc: 'Cc',
      bcc: 'Bcc',
      deleteConfirm: 'Are you sure you want to delete these tickets ?',
      deleteNote: 'Choosing this option will delete mails permanently',
      selectTickets: 'Select tickets',
      sentSuccess: 'Mail sent!',
      mergeSuccess: 'Merged Successfully',
      body: 'Body',
      note: 'Note',
      deleteMailsTo: 'Delete mails too?',
      all: 'All',
      notAssigned: 'Not Assigned',
      addTicketType: 'Add ticket type',
      updateTicketType: 'Update ticket type',
      addPriority: 'Add Priority',
      updatePriority: 'Update Priority',
      lastModified: 'Last modified',
      assignedtoMessage: 'You are assigned to',
      by: 'by',
      awb: 'AWB',
      notes: 'Notes',
      personalNotes: 'Personal notes',
      addComments: 'Add Comments',
      createTask: 'Create Task',
      description: 'Description',
      allTickets: 'All tickets',
      myTickets: 'My Tickets',
      myOpenTickets: 'My open tickets',
      unassignedTickets: 'Unassigned tickets',
      allActive: 'All active',
      com: 'Com',
      selectAWB: 'Select AWB',
      noUser: 'No user has been assigned to this ticket. Would you like to set the active user as assigned to?',
      closed: 'Closed',
      tasks: 'Tasks',
      convertToTicket: 'Convert to Ticket',
      convertToTask: 'Convert to Task',
      createOffer: 'Create Offer',
      signature: 'Ticket signature',
      dontSendAutoreply: 'Dont send autoreply',
      dontSendNotification: 'Dont send notification',
      isOpen: 'Is open',
      canReOpen: 'Can re open',
      daysToNotify: 'Days to notify status not changed',
      isDomain: 'Is domain',
      autoAssignTicketStatus: 'Auto assign status',
      autoAssignTicketUser: 'Auto assign user',
      addAutoassignStatus: 'Add auto assign status',
      updateAutoassignStatus: 'Update auto assign status',
      addAutoassignUser: 'Add auto assign user',
      updateAutoassignUser: 'Update auto assign user',
      groupOrUser: 'Group or User',
      is: 'Is',
      fromAddress: 'From address',
      toAddress: 'To address',
      addFilter: 'Add filter',
      updateFilter: 'Update filter',
      noUserAssigned: 'No user has been assigned to this ticket. Would you like to set the active user as assigned to?',
      lastReceivedorsent: 'Last received/sent',
      for: 'For',
      customerSet: 'Set customer',
      customerChanged: 'Customer changed from',
      categorySet: 'Set category',
      categoryChanged: 'Category changed from',
      sureToChangeStatus: 'Are you sure want to change status ?',
      statusSet: 'Set status',
      statusChanged: 'Status changed from',
      prioritySet: 'Set priority',
      priorityChanged: 'Priority changed from',
      latestContentFound: 'Newly assigned tickets are available!',
      refreshTickets: 'Refresh tickets'
    },
    mailConfiguration: {
      name: 'Name',
      host: 'Host',
      port: 'Port',
      usessl: 'UseSsl',
      username: 'UserName',
      password: 'Password',
      dosync: 'DoSync',
      syncfrom: 'Sync date',
      synctime: 'Sync time',
      lastsynced: 'Last Synced',
      signature: 'Mail Signature',
      addMailConfig: 'Add Mail Configuration',
      updateMailConfig: 'Update Mail Configuration',
      testConnection: 'Test Connection',
      connectionSuccess: 'Connection successful!',
      connectionFail: 'Connection failed!',
      action: 'Action'
    },
    systemConfiguration: {
      ticketterm: 'Ticket Term',
      enableawb: 'Enable #AWB',
      syncinterval: 'Sync Interval (in minutes)',
      systemConfig: 'Ticketing Configuration',
      ticketCreation: 'Ticket creation response'
    },
    deviations: {
      title: 'Title',
      location: 'Location',
      category: 'Category',
      estimate_cost: 'Estimate Cost',
      estimatedInternalCost: 'Estimated internal cost',
      estimatedCustomerCost: 'Estimated customer cost',
      internalCost: 'Internal cost',
      customerCost: 'Customer cost',
      deviationReport: 'Deviation report',
      severity: 'Severity',
      addDeviation: 'Add Deviation',
      updateDeviation: 'Update Deviation',
      reported_by: 'Reported By',
      reason: 'Reason',
      underlying_reason: 'Underlying Reason',
      corrective_actions: 'Corrective Actions',
      effective_of_measures: 'Effect of Measures',
      responsible: 'Responsible',
      copy_to: 'Copy To',
      created_on: 'Created on',
      deadline: 'Deadline',
      deviationcategories: 'Deviation Categories',
      locationtype: 'Location Type',
      printChart: 'Print chart',
      downloadPNG: 'Download PNG',
      downloadJPEG: 'Download JPEG',
      downloadPDF: 'Download PDF',
      downloadSVG: 'Download SVG',
      statistics: 'Statistics',
      deviation_report: 'Deviation Report',
      incharge: 'In charge',
      filter: 'Filter',
      deadlineFrom: 'Dead Line From',
      deadlineTo: 'Dead Line To',
      addMeasures: 'Add measures',
      updateMeasures: 'Update measures',
      measures: 'Measures',
      genertate_pdf_with_attachment: 'Download pdf with attachment',
      registert: 'Date',
      openMeasureExists: 'Deviation can\'t be closed, since one of the measures are open',
      measureExists: 'Deviation can\'t be closed, requires at least 1 measure must be created!',
      categories: 'Categories',
      openedDeviation: 'Opened deviations',
      searchForSupplier: 'Search for supplier'
    },
    severity: {
      select: 'Select severity',
      low: 'Low',
      medium: 'Medium',
      high: 'High'
    },
    hse: {
      hseSystem: 'HSE-SYSTEM',
      uploadDocument: 'Upload Document',
      gettingFolders: 'Getting Folders From SharePoint.... Please wait...',
      noDocuments: 'NO DOCUMENTS FOUND!',
      noFolders: 'NO FOLDERS FOUND!',
      createNew: 'Create folder',
      editName: 'Edit folder',
      deleteFolder: 'Delete folder',
      upload: 'Upload',
      folderName: 'Folder name',
      files: 'Files',
      noResponsible: '*no responsible',
      noDescription: '*no description',
      updateMetaData: 'Update Meta Data',
      openNewTab: 'Open in new Tab',
      editMeta: 'Edit Meta'
    },
    deviationSettings: {
      addCategory: 'Add Deviation Category',
      updateCategory: 'Update Deviation Category',
      addStatus: 'Add Deviation Status',
      updateStatus: 'Update Deviation Status',
      addLocation: 'Add Deviation Location',
      updateLocation: 'Update Deviation Location'
    },
    datestrings: {
      year: 'Year',
      today: 'Today',
      month: 'Month',
      quarter: 'Quarter',
      previousMonth: 'Previous month',
      lastMonth: 'Last {month} month(s)'
    },
    onedriveSettings: {
      oneDriveSetup: 'Configure the base folders for HSE and Products.',
      selectHse: 'Select HSE base',
      selectProduct: 'Select Product base',
      selectCustomer: 'Select Customer base',
      selectDeviation: 'Select Deviation base',
      odLink: 'Onedrive Link'
    },
    sharepointSettings: {
      baseUrl: 'Base url',
      siteUrl: 'Site url',
      listName: 'List name',
      loadFolders: 'Load folders',
      loadList: 'Load List',
      propertiesConfig: 'Properties Configuration',
      contentType: 'Content Type',
      configureSharepointCreds: 'Please configure Sharepoint Credentials!',
      changeUser: 'Change user',
      sharepointAlertMsg: 'The account used here to login will be considered as System User ({userName})',
      config: 'SharePoint Configurations'
    },
    shipment: {
      addShipment: 'Add shipment',
      updateShipment: 'Update Shipment',
      bring: 'Bring',
      tnt: 'TNT',
      postnord: 'Postnord'
    },
    industry: {
      addIndustry: 'Add industry',
      updateIndustry: 'Update industry'
    },
    permissions: {
      manageShifts: 'Manage shift',
      manageOpencartOrders: 'Manage opencart order',
      manageShopboxOrders: 'Manage shopbox order',
      manageSettings: 'Manage settings'
    },
    currency: {
      addCurrency: 'Add currency',
      updateCurrency: 'Update currency',
      exchangeRate: 'Exchange Rate',
      validFrom: 'Valid From',
      currencyHistories: 'Currency histories'
    },
    unit: {
      addUnit: 'Add product unit',
      updateUnit: 'Update product unit'
    },
    whOrder: {
      orderedQty: 'Ordered Qty',
      unitCost: 'Unit Cost',
      supplierOrder: 'Supplier order',
      adjustmentOrder: 'Adjustment order',
      returnOrder: 'Return order',
      transferOrder: 'Transfer order',
      addSupplierOrder: 'Add Supplier Order',
      updateSupplierOrder: 'Update Supplier Order',
      addAdjustmentOrder: 'Add Adjustment Order',
      updateAdjustmentOrder: 'Update Adjustment Order',
      addReturnOrder: 'Add Return Order',
      updateReturnOrder: 'Update Return Order',
      addTransferOrder: 'Add Transfer Order',
      updateTransferOrder: 'Update Transfer Order',
      orderType: 'Ordertype',
      from: 'From',
      to: 'To',
      orderDate: 'Order date',
      estimated: 'Estimated',
      requested: 'Requested date',
      confirmed: 'Confirmed date',
      comments: 'Message to supplier',
      internalComments: 'Internal comments',
      internalCom: 'Internal comments',
      warehouseCom: 'Warehouse comments',
      estimateDelivery: 'Estimate/Delivery date',
      withLocations: 'With locations',
      withoutLocations: 'Without locations',
      pickFiles: 'Choose files',
      orderQty: 'Order qty',
      recQty: 'Rec.qty',
      productNotAvailbleMsg: 'Selected product not available in the location!',
      onstockLessMsg: 'Qty should not be less than stock!',
      orderedQtyLessMsg: 'Picked qty cannot be higher than ordered!',
      sameProductMsg: 'Select Different product',
      minQty: 'Min. qty',
      availQty: 'Avail.qty',
      sourceWH: 'Source whs',
      destinationWH: 'Destination whs',
      pickQty: 'Picked. qty',
      loc: 'Loc',
      ordQty: 'Ord.qty',
      batch: 'Batch',
      noLoc: 'No Loc.',
      orderProposal: 'Order proposal',
      qtySame: 'Rec.qty should be same as ordered qty',
      reserved: 'Reserved',
      allData: 'All data',
      supplierPrices: 'Supplier prices',
      expireDate: 'Expiry date',
      receiveAll: 'Receive all',
      avail: 'Avail.',
      deliverTo: 'Deliver to',
      leaveBlank: 'Leave blank for delivery to',
      withPrices: 'With prices',
      emailSentTo: 'Email sent to {email}, by {user} on {date}',
      labeled: 'Labeled',
      ourContact: 'Our contact',
      discount: 'Discount',
      discounted: 'Discounted',
      reverseReceived: 'Are you sure to reverse received qty?'
    },
    stock: {
      onStock: 'On Stock',
      onOrder: 'On Order',
      location: 'Location',
      warehouseLoc: 'Warehouse/Location',
      costPrice: 'Cost Price',
      onCustomerOrder: 'On Customer Order',
      importLocations: 'Import warehouse locations',
      toDeliver: 'To deliver'
    },
    ccsheet: {
      addCCSheet: 'Add CCSheet',
      updateCCSheet: 'Update CCSheet',
      ongoing: 'On going',
      onStock: 'On stock',
      counted: 'Counted',
      recount: 'Recount',
      completed: 'Completed',
      completedAndAdjusted: 'Completed and adjusted',
      useScanner: 'Use Scanner',
      noProductsFound: 'No Products found',
      proceed: 'Proceed',
      scannerLocation: 'Scan / Search by location',
      searchLocation: 'Filter by location',
      scanProduct: 'Scanning Product',
      ccsheetReport: 'CCSheet',
      completeSheet: 'Would you really like to close current stock count?',
      countedTotal: 'Counted Total',
      totalValues: 'Total values',
      diff: 'Diff',
      cannotPickAtThisWH: 'We have open ccsheet for this product, can\'t pick at this moment',
      quickCount: 'Quick count',
      quick: 'Quick',
      itemsToCount: 'Hva skal telles',
      all: 'All',
      stockItems: 'Stock items',
      nonStockItems: 'Non stock items'
    },
    contact: {
      title: 'Title',
      contactLookupHeader: 'Contact Information from lookup',
      nameExists: 'Name Already Exists',
      lookupModelHeader: 'You have selected contact that alreadt exists. Do you want to continue ?',
      telephoneMobileNumber: 'Telephone/Mobile',
      hasBrreg: 'Having BRREG lookup?',
      has1881: 'Having 1881 lookup?'
    },
    orders: {
      salesReference: 'Sales Reference',
      addOrder: 'Add Order',
      updateOrder: 'Update Order',
      contact: 'Contact',
      customercontact: 'Customer contact',
      deliveryAddress: 'Delivery address',
      invoiceAddress: 'Invoice address',
      invoiceTo: 'Invoice to',
      orderFor: 'Order for',
      ourReference: 'Our reference',
      yourReference: 'Your reference',
      offerInformation: 'Order Information',
      offerComments: 'Offer text and comments',
      orderComments: 'Order text and comments',
      standardSales: 'Standard Sales',
      deliveryTerms: 'Delivery Terms',
      totalExVat: 'Total Ex VAT',
      totalSum: 'Total Sum',
      productNo: 'Product No.',
      price: 'Price',
      dataSheet: 'Datasheet',
      searchForProduct: 'Search for product...',
      offerDate: 'Offer date',
      shipDate: 'Ship date',
      offerDueDate: 'Offer due date',
      orderDate: 'Order date',
      deliveryDate: 'Delivery date',
      forProduction: 'For production',
      pick: 'Pick',
      forApproval: 'For approval',
      toInvoice: 'To invoice',
      invoiced: 'Invoiced',
      projectCompleted: 'Project completed',
      cancelled: 'Cancelled',
      orderDetails: 'Order Details',
      materials: 'Materials',
      billingData: 'Billing Data',
      approve: 'Approve',
      addNew: 'Add New',
      pQty: 'P.Qty',
      user: 'User',
      invoiceQty: 'Invoice Qty',
      addNewProduct: 'Add New Product',
      history: 'History',
      createdBy: 'Created by',
      lastUpdated: 'Last updated',
      billingTotalExVat: 'Billing total ex VAT',
      offerPart: 'Offer part',
      assignment: 'Assignment',
      tasksPerformed: 'Tasks Performed',
      packList: 'Packing list',
      nvitPackList: 'NVIT packing list',
      pickList: 'Picking list',
      proformaInvoice: 'Proforma Invoice',
      printLabels: 'Print labels',
      orderHasBeenCreated: 'Order for this offer has already been created, do you want to create a new one?',
      customerOrder: 'Customer/Supplier',
      includeAllApprovedProduct: 'Do you want to include all approved products in invoice draft?',
      productNotApprovedExclude: 'Products without approval will be excluded from invoice. Do you want to continue?',
      invoiceSelectRows: 'At least one product row must be selected',
      changesNotSaved: 'Changes have not been saved. Do you want to save and proceed?',
      generateRestOrder: 'The order has not been picked completely. Would you like to invoice and generate rest order?',
      restOrderFor: 'Rest order for',
      restOrder: 'Rest order',
      storeSales: 'Store sales',
      storeWeb: 'Store vs Web',
      store: 'Store',
      web: 'Web',
      totalInvoiced: 'Total Invoiced',
      totalOrders: 'Total Orders',
      stockAvailable: 'Stock available',
      inBacklog: 'In backlog',
      standardOfferText: 'Standard offer text',
      standardOrderText: 'Standard order text',
      standardDeliveryTerms: 'Standard delivery terms',
      offerText: 'Offer text',
      orderText: 'Order text',
      restQty: 'Rest qty',
      unknown: 'Unknown',
      archicad: 'Archicad import',
      zone: 'Zone',
      perzone: 'per zone',
      existingDataOverwritten: 'Existing data will be overwritten, are you sure want to proceed?',
      allDataOverwritten: 'All existing values will be overwritten!',
      discountForAllPrice: 'Do you want to change the discount for all products?',
      contents: 'Contents',
      noZone: 'No zone',
      totalRows: 'Total rows',
      stockablePackage: 'Stockable packages',
      yourOrderNumber: 'Your order number',
      salesDate: 'Sales date',
      salesValue: 'Sales value',
      salenew: 'New',
      sold: 'Sold',
      lost: 'Lost',
      createSales: 'Create sales',
      createSalesWithoutTemp: 'Create sales without template',
      sendFromWH: 'Shipping week',
      installationWeek: 'Installation week',
      installationCompleted: 'Installation completed',
      orderTotal: 'Ordresum',
      deliveryTime: 'Delivery time',
      valuesCannotBeNegative: 'Prices can\'t be negative',
      invoiceComments: 'Invoice comments',
      totalAmountNegativeWarning: 'Total amount to invoice is less than 0. Would you like to create credit note?',
      supplierNotSelectedOrder: 'Supplier is not selected for at least one row. Do you want to proceed?',
      customerDataChanged: 'Customer data is changed. Would you like to update open offers/orders?'
    },
    discountGrp: {
      customerGroup: 'Customer groups'
    },
    invoice: {
      saveAs: 'Save As',
      saveAsDraft: 'Save as Draft',
      saveAndEmail: 'Save and Email',
      saveAndDownloadPDF: 'Save and download PDF',
      saveAndUseEHF: 'Save and use EHF (Auto invoice)',
      yourReference: 'Your Reference',
      yourContact: 'Your Contact',
      ourReference: 'Our Reference',
      invoicedDate: 'Invoiced Date',
      duedate: 'Due Date',
      invoicing: 'Invoicing',
      completedDate: 'Completed Date',
      rbt: 'Rbt',
      sum: 'Sum',
      sumeksMva: 'Eks VAT',
      totalExVat: 'Total ex.VAT',
      MVA: 'MVA',
      roundDown: 'Round Down',
      invoiceTotal: 'Invoice total incl',
      invoicePreview: 'Preview',
      addInvoice: 'Add Invoice',
      updateInvoice: 'Update Invoice',
      createCreditNote: 'Create Credit Note',
      updateCreditNote: 'Update Credit Note',
      pmtTerms: 'PMT Term',
      days: 'Days',
      exportToVisma: 'Export To Visma',
      showAll: 'Show all',
      groupByCustomer: 'Group by customer',
      exported: 'Exported',
      totalSum: 'Total sum',
      cantDelete: 'Invoice can\'t be deleted!',
      toBeExported: 'To be exported',
      invoiceNumber: 'Invoice number',
      basePrice: 'Base price',
      priceIncVat: 'Inc VAT',
      invoiceCreatedBy: 'Invoice Created By',
      onDate: 'on',
      by: 'by',
      creditNoteCreatedBy: 'Credit note created by',
      createdFrom: 'Created from',
      creditConfirm: 'Are you sure you want to create credit note ?',
      confirmation: 'Confirmation',
      searchProduct: 'Search Product',
      creditNote: 'Credit note',
      hoursConfirm: 'There are hours that have not been approved yet, would you like to continue to create the invoice ?',
      productsConfirm: 'No products has been added, would you like to continue to create the invoice?',
      hoursProducts: 'Do you want to include hours & products from order ?',
      qty: 'Qty',
      hoursProductAvail: 'Hours and products should be available for invoicing?',
      pressHold: '*Press and Hold <code>Ctrl</code> key to select more',
      subject: 'Mail Subject',
      body: 'Mail Body',
      signature: 'Mail Signature',
      prefixInvoiceNumber: 'invoice_number',
      resendEhf: 'Resend EHF',
      resendEmail: 'Send email',
      standardInvoiceText: 'Standard invoice text',
      statusDraft: 'Draft',
      statusProgress: 'In progress',
      statusSent: 'Sendt/Downloaded',
      invoiceEmail: 'Invoice email',
      invoiceNotSaved: 'Invoice is not saved. Do you want to continue?',
      removeFromFixedPrice: 'Remove from fixed price',
      deleteFromInvoice: 'Delete from invoice',
      createAkonto: 'New akonto',
      newInvoice: 'New invoice',
      fixedPriceOnly: 'Fixed price row only',
      deleteWithArticles: 'Delete with articles',
      noItemsOnInvoice: 'No items found to create the invoice!',
      draftExists: 'Invoice draft exist. Please complete or delete it',
      allInvoiced: 'Ordren er allerede fakturert.',
      noItemsOnOrder: 'No products found to create the supplier order!',
      xledger: 'xLedger',
      ehfSent: 'EHF sendt på nytt',
      ehfInfo: 'EHF sent successfully!',
      commercialInv: 'Commercial Inv.',
      invoicesCreated: 'Invoices have been created successfully!',
      invoiceFailedtoSend: 'Invoice has been generated, but email sending failed. Please download pdf and send manually.',
      invoiceEHFFailed: 'Something went wrong during EHF generation. The Support team is reported with the error.',
      statusOfInvoices: 'Status of Invoices',
      success: 'Success',
      failed: 'Failed',
      fullCredit: 'Full credit',
      partialCredit: 'Partial credit',
      abort: 'Abort',
      chooseorAbort: 'Choose type or abort',
      selectProducts: 'Select products',
      fullCreditContent: 'Credit all invoice items',
      partialCreditContent: 'Select and credit invoice items',
      resync: 'Resync to 24seven',
      invoiceDownloadedBy: 'Invoice downloaded by {user} on {date}',
      invoiceEmailedBy: 'Invoice emailed to {email} by {user} on {date}',
      invoiceEHFBy: 'EHF Invoice created by {user} on {date}',
      invoiceEHFResentBy: 'EHF Invoice resent by {user} on {date}',
      creditNoteDownloadedBy: 'Creditnote downloaded by {user} on {date}',
      creditNoteEmailedBy: 'Creditnote emailed to {email} by {user} on {date}',
      creditNoteEHFBy: 'EHF Creditnote created by {user} on {date}',
      cannotCreateInvoice: 'Invoice sum should be atleast 1!',
      invoiceBody: 'Invoice body',
      creditBody: 'Creditnote body',
      syncTo24seven: 'Sync 24seven',
      likeToSendEHF: 'Would you like to resend EHF?'
    },
    settings: {
      addShipment: 'Add Customer Shipment',
      updateShipment: 'Update Customer Shipment',
      addCustomerPriority: 'Add Customer Priority',
      updateCustomerPriority: 'Update Customer Priority',
      addIndustry: 'Add Customer Industry',
      updateIndustry: 'Update Customer Industry',
      addBuilding: 'Add Building',
      updateBuilding: 'Update Building',
      shortName: 'Short name',
      addFacility: 'Add facilities address',
      updateFacility: 'Update facilities address',
      addProductGroup: 'Add Product Group',
      updateProductGroup: 'Update Product Group',
      equipmentType: 'Equipment Type',
      refrigerant: 'Refrigerant',
      refrigerantShort: 'Refr',
      addEquipmentType: 'Add Equipment Type',
      updateEquipmentType: 'Update Equipment Type',
      addRefrigerant: 'Add Refrigerant',
      updateRefrigerant: 'Update Refrigerant',
      addOrderType: 'Add Order Type',
      updateOrderType: 'Update Order Type',
      order: 'Order',
      equipmentModel: 'Equipment Model',
      equipmentFabricate: 'Equipment Fabricate',
      equipmentDocuments: 'Equipment Documents',
      industry: 'Industry',
      generalSettings: 'General Settings',
      lockMsg: 'Lock it on',
      monthMsg: 'Every month',
      minimumHours: 'Minimum hours',
      organizationNumber: 'Organization number',
      sellerIndentificationCode: 'Seller identification code',
      companyName: 'Company name',
      accountNo: 'Account number',
      ibanBban: 'IBAN/BBAN',
      branchName: 'Branch name',
      vismaClientNumber: 'Visma client number',
      streetName: 'Street name',
      countryIdentityCode: 'Country identification code',
      contactName: 'Contact name',
      contactTelephone: 'Contact telephone',
      contactEmail: 'Contact Email',
      companyInfo: 'Company information',
      postAddress: 'Post address',
      standardInvoiceText: 'Standard invoice text',
      category: 'Category',
      sendAutoReply: 'Send auto reply',
      autoReply: 'Auto reply',
      priceRecalculation: 'All prices that match criteria will be recalculated.'
    },
    unimicro: {
      pageTitle: 'Unimicro Setting',
      customerNumber: 'Customer number',
      systemMailAddress: 'System mail address',
      csvDelimiter: 'CSV Delimiter',
      createReport: 'Create report',
      updatedBy: 'Updated by',
      updatedOn: 'Updated on',
      preview: 'Preview',
      sendReport: 'Send Report',
      employeeNumber: 'Employee number',
      salaryCode: 'Salary code',
      rate: 'Rate',
      accountNumber: 'UniMicro account number',
      supplierNumber: 'Supplier number',
      payGrade: 'Pay grade',
      organizationNumber: 'Organization number',
      entryNo: 'Entry no',
      dim: 'Dim',
      numberToInvoice: 'Number to invoice',
      retailPrice: 'Retail price',
      orderNumber: 'Order number',
      kommunenr: 'Kommunenr',
      createdBy: 'Created by',
      createdOn: 'Created on',
      datesMandatory: 'Dates must be selected',
      pending: 'Pending',
      sent: 'Sent'
    },
    dashboard: {
      topCustomers: 'Top Customers',
      turnOverMonth: 'Turnover this month',
      last: 'Last',
      current: 'Current',
      week: 'week',
      month: 'month',
      year: 'year'
    },
    invoiceReport: {
      line: 'Number',
      productDescription: 'Product description',
      businessEnterprises: 'The Register of Business Enterprises',
      ourRef: 'Our ref',
      yourRef: 'Your ref',
      ourReference: 'Our reference',
      yourReference: 'Your reference',
      yourContact: 'Your contact',
      betBet: 'P. terms',
      paymentTerms: 'Payment terms',
      levBet: 'D. terms',
      deadline: 'Deadline',
      invoiceDate: 'Invoice date',
      customerInfo: 'Cust info',
      customerNo: 'Cust no',
      tel: 'Tel',
      telephone: 'Phone',
      accNo: 'Acc no',
      orderNo: 'Order no',
      mobile: 'Mobile',
      roundOff: 'Round off',
      totalIncVat: 'Total incl. vat',
      kid: 'Kid',
      amountToPay: 'Amount to pay',
      paymentDeadline: 'Payment deadline',
      orgNo: 'Org. no',
      saleRef: 'Sales ref',
      labeled: 'Label'
    },
    userRole: {
      administrator: 'Administrator',
      office: 'Office',
      technician: 'Technician',
      technicians: 'Technicians'
    },
    reports: {
      turnover: 'Turnover report',
      runReport: 'Run report',
      inventoryReport: 'Inventory report',
      totalInventoryValue: 'Total Inventory value',
      locations: 'Locations',
      vendor: 'Vendor',
      totalInventory: 'Total Inventory',
      prodNo: 'Prod.nr',
      totalCosts: 'Total costs',
      averageDG: 'Average DG',
      monthUsage: '12 months usage'
    },
    paymentTerm: {
      add: 'Add Payment terms',
      update: 'Update Payment terms',
      enterNoOfDays: 'Enter No.of days'
    },
    deliveryTerm: {
      add: 'Add Delivery terms',
      update: 'Update Delivery terms'
    },
    turnoverReport: {
      turnover: 'Turnover',
      dg: 'DG',
      Groupby: 'Group by',
      GroupbyYear: 'Group by year',
      GroupbyMonth: 'Group by month',
      groupbycustomer: 'Group by customer'
    },
    props: {
      new: 'New',
      name: 'Name',
      description: 'Description',
      label: 'Label',
      type: 'Type',
      placeholder: 'Placeholder',
      isActive: 'Is Active',
      actions: 'Actions',
      value: 'Value',
      properties: 'properties',
      options: 'Options',
      addProps: 'Add Properties',
      updateProps: 'Update Properties',
      formAttributes: 'FORM ATTRIBUTES',
      useAsTitle: 'Use as title',
      validation: 'Validation',
      isMultiSelect: 'Is multiselect',
      defaultValue: 'Default Value',
      enterValue: 'Enter one of the values from option',
      isApi: 'Is API',
      apiUrl: 'API URL',
      objectName: 'Object name',
      columns: 'Columns',
      gridColumns: 'Grid Columns',
      question: 'Question ?',
      link: 'Html',
      enterTitleOfColumn: 'Enter Title Of Each Columns',
      loadingGrid: 'Loading grids...',
      favourite: 'Favourite',
      customProperties: 'Custom Properties',
      enterTitle: 'Enter Title',
      rows: 'Rows',
      preparingFields: 'Preparing Fields',
      dragging: 'Dragging...',
      fontSize: 'Font size',
      preview: 'Preview',
      hideComments: 'Hide Comments',
      hideAttachments: 'Hide Attachments',
      defaultValueKeyword: 'Default Value by keyword',
      setCurrentUserAsDefault: 'Set current user as default',
      rowsToAutoCreate: 'Rows to auto create on checklist create',
      showInNextRow: 'Show in next row',
      addTopSpace: 'Add top space',
      optionsValuesAreNotUnique: 'Options list values are not unique',
      viewType: 'View type',
      showWidthField: 'Show width field above header',
      enterTitleAndWidthOfColumn: 'Enter title and width of the column',
      fieldInfo: 'Field info',
      valueForCalculation: 'Value for calculation',
      customFieldsNotAvailable: 'Custom field not available',
      selectStatus: 'Select status',
      template: 'Template',
      drag: 'Drag',
      showSum: 'Show sum',
      moduleFields: 'Module fields (Title: Placeholder)',
      placeHolderUsageMessage: 'Use placeholders within {} in templates. Ex: {Name}'
    },
    form: {
      updateFormProps: 'Update Form Properties',
      addNewForm: 'Add new form',
      selectGroup: 'Select group',
      addHeader: 'Add Header',
      addFooter: 'Add Footer',
      formProps: 'FORM PROPERTIES',
      allCaughtUp: 'All caught up!',
      dropFields: 'Drop the fields here!',
      addHtmlContent: 'ADD HTML CONTENT',
      forHeader: 'FOR HEADER',
      forFooter: 'FOR FOOTER',
      comments: 'Comments',
      attachments: 'Attachments',
      sureToCloneFields: 'Are you sure want to clone fields?',
      documents: 'Documents',
      document: 'Document',
      updateDocument: 'Update Document',
      addGroup: 'Add Group',
      updateGroup: 'Update Group',
      date: 'Date',
      signature: 'Signature'
    },
    checklist: {
      addChecklist: 'Add checklist',
      updateChecklist: 'Update checklist',
      sendChecklist: 'Send checklist'
    },
    documents: {
      documentSignature: 'Document signature',
      emailMessage: 'Email message',
      invitationValidTill: 'Invitation is valid until',
      emailDocumentsAfterSigning: 'Email documents after signing',
      signeeShouldReadDocument: 'Require the signee to read the document',
      signers: 'Signers',
      allowSigningWithoutStrongAuthentication: 'Allow signing without strong authentication',
      signAsOrganization: 'Sign as organization',
      notifyInviteesWhenEveryoneHasSigned: 'Notify invitees when everyone has signed',
      reminderDate: 'Reminder date',
      signInSpecifiedOrder: 'Signature in specified order',
      validityTime: 'Validity time',
      signatureType: 'Signature type',
      withoutStrongAuthentication: 'Without strong authentication',
      strongAuthentication: 'Strong authentication'
    }
  }
}
